var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth"},[_vm._m(0),_c('div',{staticClass:"mt-6"},[_c('v-btn',{staticClass:"white--text",attrs:{"color":"mainNew","loading":_vm.loading},on:{"click":_vm.login}},[_vm._v("Далее")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Авторизация не требуется")])])
}]

export { render, staticRenderFns }